import React, {useEffect, useState, useRef} from 'react';
import {useLocation,useNavigate,Link,useParams} from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { BiSolidLeftArrow, BiSolidRightArrow } from 'react-icons/bi';
import {CgSoftwareDownload} from 'react-icons/cg';
import { FiChevronRight } from "react-icons/fi";
import Cookies from 'universal-cookie';

// import '/css/ResultTemplate.css';
import { sendAnalyticsData } from '../utilities/analytics';

import jsonData from '../template.json'
import QRCode from '@zxing/library/esm/core/qrcode/encoder/QRCode';

// const resultAPI = process.env.REACT_APP_RESULT_TEMPLATE;
const resultAPI = jsonData;
const updateAPI = 'https://wardah-colourstory.com/wsapi/users/update_color';

const PageResultTemplate = () => {
  const [isCapturing, setIsCapturing] = useState(true);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [errorConnection, setErrorConnection] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [result, setResult] = useState({});
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [subSeason, setSubSeason] = useState('');
  const [subSeasonAccuracy, setSubSeasonAccuracy] = useState('0%');
  const [subSeasonAlt, setSubSeasonAlt] = useState('0%');
  const [subSeasonAccuracyAlt, setSubSeasonAccuracyAlt] = useState('0%');
  const [complexion, setComplexion] = useState('');
  const [complexionName, setComplexionName] = useState('');
  const [complexionCode, setComplexionCode] = useState('');
  const [shareTemplate, setShareTemplate] = useState('autumn');
  const [skintoneColor, setSkintoneColor] = useState('#F3C4BF');
  
  const [complexionProducts, setComplexionProducts] = useState([]);
  // const [complexionCombinedProducts, setComplexionCombinedProducts] = useState([]);
  const [shareComplexionProducts, setShareComplexionProducts] = useState('');
  const [deviceType, setDeviceType] = useState('desktop');

  const { type } = useParams();
  const navigate = useNavigate()
  const location = useLocation();

  const captureMobileRef = useRef(null);
  const canvasRef = useRef(null);
  const pdfTriggeredRef = useRef(false);

  // const urlVto = 'https://localhost/wardah-vto-external/index.html';
  const urlVto = process.env.REACT_APP_VTO_URL || 'https://colourintelligence.wardahbeauty.com/vto';

  const mobileAndTabletCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    if(check){
      setDeviceType('mobile');
    }else{
      setDeviceType('desktop');
    }
  };

const tabs = [
  { id: "lips-section", label: "Lip Makeup" },
  { id: "eyes-section", label: "Eye Makeup" },
  { id: "blushon-section", label: "Blush On" },
];


const [active, setActive] = useState(tabs[0].id);
const tabsRef = useRef([]);

useEffect(() => {
// ensure the first tab is focusable on mount
  if (tabsRef.current[0]) tabsRef.current[0].setAttribute("tabindex", "0");
}, []);

function handleClick(id) {
setActive(id);
}

function handleKeyDown(e, idx, id) {
  const key = e.key;
  if (key === "ArrowRight") {
  const next = (idx + 1) % tabs.length;
  tabsRef.current[next]?.focus();
  setActive(tabs[next].id);
  } else if (key === "ArrowLeft") {
  const prev = (idx - 1 + tabs.length) % tabs.length;
  tabsRef.current[prev]?.focus();
  setActive(tabs[prev].id);
  } else if (key === "Home") {
  tabsRef.current[0]?.focus();
  setActive(tabs[0].id);
  } else if (key === "End") {
  tabsRef.current[tabs.length - 1]?.focus();
  setActive(tabs[tabs.length - 1].id);
  } else if (key === "Enter" || key === " ") {
  setActive(id);
  }
}

  const SlickButton = ({currentSlide, slideCount, children, ...props}) => (
    <a {...props}>{children}</a>
  );
  
  const arrowSlider = {
    nextArrow: 
      <SlickButton className="slick-arrow slick-next">
          <BiSolidRightArrow/>
      </SlickButton>,
    prevArrow: 
      <SlickButton className="slick-arrow slick-prev">
          <BiSolidLeftArrow/>
      </SlickButton>
  }
  
  const settingsLipsSection = {
    dots: false,
    infinite: false,
    accessibility: true,
    arrows: true,
    speed: 800,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    slidesToShow: 1,
    ...arrowSlider
  };
  
  // Helper function to chunk array into groups of size n
  function chunkArray(array, size) {
    return array.reduce((acc, _, i) => (i % size ? acc : [...acc, array.slice(i, i + size)]), []);
  }
  
  
  const RenderProductsLipsMobile = ({data = []}) => {
    
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: true,
      arrows: false,
      adaptiveHeight: false,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      return (
        <>
          <div className='list-product-lips' key={JSON.stringify(data)}>
            {data.map((category, index) => {
              return (
                <div className='list-product' key={index}>
                  <div className='product-content'>
                    <div className='side-image'>
                      {
                      index === 0 ?
                      <>
                        <img src='/assets/images/products/image-glossicle.png' alt='' />
                      </>
                      :
                      index === 1 ?
                      <>
                        <img src='/assets/images/products/image-airbrush.png' alt='' />
                      </>
                      :
                      index === 2 ?
                      <>
                        <img src='/assets/images/products/image-lip-cream.png' alt='' />
                      </>
                      :
                      index === 3 ?
                      <>
                        <img src='/assets/images/products/image-lip-glasting.png' alt='' />
                      </>
                      :
                      index === 4 ?
                      <>
                        <img src='/assets/images/products/image-moist-dew.png' alt='' />
                      </>
                      :
                      index === 5 ?
                      <>
                        <img src='/assets/images/products/image-lip-mousse.png' alt='' />
                      </>
                      :
                      index === 6 ?
                      <>
                        <img src='/assets/images/products/image-lip-paint.png' alt='' />
                      </>
                      :
                      index === 7 ?
                      <>
                        <img src='/assets/images/products/image-lipstick.png' alt='' />
                      </>
                      :
                      index === 8 ?
                      <>
                        <img src='/assets/images/products/image-staylock.png' alt='' />
                      </>
                      :
                      index === 9 ?
                      <>
                        <img src='/assets/images/products/image-glacier.png' alt='' />
                      </>
                      :
                      index === 10 ?
                      <>
                        <img src='/assets/images/products/image-lip-plush.png' alt='' />
                      </>
                      :
                      null
                      }
                    </div>
                    <div className='product-right-slider'>
                      <div className="title-category-image">
                        {/* <img src={category.categoryImage} alt=''/> */}
                        {category.category}
                      </div>
                      <div className='subtitle-category'>
                        <div className='sub-category'>{category.subCategory}</div>
                        <span className='hint-swipe'>swipe to see <FiChevronRight /></span>
                      </div>
                      <Slider key={index} className='product-slider' {...settingsProduct}>
                        {category.item.map((item, itemIndex) => (
                          <div key={itemIndex} className='product-slide'>
                            <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
                              {item.image ?
                                <img src={item.image} alt='' />
                                :
                                <span className='bg-dark'></span>
                              }
                            </a>
                            <div className='product-name text-center'>{item.name}</div>
                          </div>
                        ))}
                        {/* <div className='product-slide' style={{opacity: '0'}}>
                          <a className='image-product'>
                            <img src={null} alt='' />
                          </a>
                        </div> */}
                      </Slider>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </>
      );
    }
  
    return null;
  }
  
const RenderProductsLipsEye = ({ data = [] }) => {
  const settingsProduct = {
    dots: false,
    infinite: false,
    accessibility: true,
    arrows: false,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 4,
    ...arrowSlider
  };

  // only keep index 2 and 3
  const visible = data.slice(2, 4);

  if (visible.length !== 0) {
    return (
      <>
        <div className="list-product-lips" key={JSON.stringify(visible)}>
          {visible.map((category, index) => {
            return (
              <div className="list-product" key={index}>
                <div className="product-content">
                  <div className="side-image">
                    { (index + 2) === 0 ? null : null }
                    {(index + 2) === 2 ? (
                      <img src="/assets/images/products/image-lip-cream.png" alt="" />
                    ) : (index + 2) === 3 ? (
                      <img src="/assets/images/products/image-lip-glasting.png" alt="" />
                    ) : null}
                  </div>

                  <div className="product-right-slider">
                    <div className="title-category-image">
                      {category.category}
                    </div>
                    <div className="subtitle-category">
                      <div className="sub-category">{category.subCategory}</div>
                      <span className="hint-swipe">swipe to see <FiChevronRight /></span>
                    </div>

                    <Slider key={index} className="product-slider" {...settingsProduct} style={{width: '100%', maxWidth: '100%'}}>
                      {category.item.map((item, itemIndex) => (
                        <div key={itemIndex} className="product-slide py-0">
                          <a
                            className="image-product" style={{aspectRatio: 'unset'}}
                            href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`}
                            onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}
                          >
                            {item.image ? (
                              // <img src={item.image + '?withheaders='} alt="" />
                              <div className='hex-color' style={{backgroundColor: item.color}}></div>
                            ) : (
                              <span className="hex-color bg-dark"></span>
                            )}
                          </a>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </>
    );
  }

  return null;
}

  
  const RenderProductsLips = ({ data = [] }) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: true,
      arrows: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      ...arrowSlider
    };
    if (data.length !== 0) {
  
      var groupedData = data;
  
      if(data.length > 4){
        groupedData = chunkArray(data, 4);
        return (
          <Slider className='slider-lips-section product-slider' {...settingsLipsSection}>
            {groupedData.map((group, groupIndex) => (
              <div className="wrapper-section-lips" key={groupIndex}>
                {group.map((category, index) => (
                  <div className='list-product pb-2 pb-md-2' key={index}>
                    <div className="title-category-image text-center">
                      <img src={category.categoryImage} alt='' />
                    </div>
                    <Slider key={index} className='product-slider' {...settingsProduct}>
                      {category.item.map((item, itemIndex) => (
                        <div key={itemIndex} className='product-slide'>
                          <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}>
                            {item.image ?
                              <img src={item.image} alt='' />
                              :
                              <span className='bg-dark'></span>
                            }
                          </a>
                          <div className='product-name'>{item.name}</div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        );
      }else{
        return(
          groupedData.map((group, groupIndex) => (
            <div className='list-product pb-4 pb-md-2' key={groupIndex}>
              <div className="title-category-image text-center">
                <img src={group.categoryImage} alt='' />
              </div>
              <Slider key={groupIndex} className='product-slider' {...settingsProduct}>
                {group.item.map((item, itemIndex) => (
                  <div key={itemIndex} className='product-slide'>
                    <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=lipstick&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}>
                      {item.image ?
                        <img src={item.image} alt='' />
                        :
                        <span className='bg-dark'></span>
                      }
                    </a>
                  </div>
                ))}
              </Slider>
            </div>
          ))
        )
      }
    }
  
    return null;
  }
  
  const RenderProductsBlushOn = ({data = []}) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      adaptiveHeight: false,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 2,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      return (
        <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
          {data.map((item, itemIndex) => (
            <div key={itemIndex} className='product-slide'>
              <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=blush&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
                {item.image ?
                  <img src={item.image} alt='' />
                  :
                  <span className='bg-dark'></span>
                }
              </a>
              <p className='product-name' style={{marginBottom: '2px'}}>{item.category}</p>
              <div className='sub-category mt-2'>{item.subCategory}</div>
              <div className='link-button-product' style={{backgroundColor: item.color}}>
                {item.code} {item.name}
              </div>
            </div>
          ))}
        </Slider>
      );
    }
  
    return null;
  };
  
  const RenderComplexion = ({data = []}) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      return (
        <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
          {data.map((item, itemIndex) => (
            <div key={itemIndex} className='product-slide'>
              <a className='image-product' href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=blush&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
                {item.image ?
                  <img src={item.image} alt='' />
                  :
                  <span className='bg-dark'></span>
                }
              </a>
              <p><span className='d-block' style={{marginBottom: '2px'}}>{item.category}</span> <strong>{item.code}</strong> {item.name}</p>
            </div>
          ))}
        </Slider>
      );
    }
  
    return null;
  };
  
  const RenderProductsEyes = ({data = [], isMobile = false}) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      adaptiveHeight: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      ...arrowSlider
    };
  
    if (data.length !== 0) {
      if(isMobile){
        return(
          <>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='product-eye pb-4'>
                <div className="title-category-image d-table mb-3 mx-auto">
                  <img src={item.categoryImage} alt=''/>
                </div>
                {item.item.map((i, index) => (
                  <div key={index} onClick={()=>{sendAnalyticsData('Click',`Product ${i.link}`)}} className='image-product d-flex mb-2' style={{aspectRatio: 'unset'}}>
                    {i.colors && !i.image?
                      i.colors.map(function(color, index) {
                        return <a className='palette-grid-item' key={index}
                        href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}}></a>
                      })
                      :
                      null
                    }
                    {
                      i.image ?
                      <div className="wrapper-eyeshadow-glitter">
                        <img src={i.image} alt='' />
                        {i.colors.map(function(color, index) {
                          return <a className='palette-grid-item' key={`eyeshadow-${index}`}
                          href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}} data-eyeshadow-type={color}></a>
                        }
                        )}
                      </div>
                      :
                      null
                    }
                  </div>
                ))}
              </div>
            ))}
          </>
        )
      }else{
        return (
          <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='product-slide'>
                <div className="title-category-image d-table mb-3 mx-auto">
                  <img src={item.categoryImage} alt=''/>
                </div>
                {item.item.map((i, index) => (
                  <div onClick={()=>{sendAnalyticsData('Click',`Product ${i.link}`)}} key={index} className='image-product d-flex mb-2' style={{aspectRatio: 'unset'}}>
                    {i.colors && !i.image?
                      i.colors.map(function(color, index) {
                        return <a className='palette-grid-item' key={index} 
                        href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}}></a>
                      })
                      :
                      null
                    }
                    {
                      i.image ?
                      <div className="wrapper-eyeshadow-glitter">
                        <img src={i.image} alt='' />
                        {i.colors.map(function(color, index) {
                          return <a className='palette-grid-item' key={`eyeshadow-${index}`}
                          href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=eyeshadow&color=${color ? color.replace('#', '%23') : ''}`} style={{'backgroundColor': color}} data-eyeshadow-type={color}></a>
                        }
                        )}
                      </div>
                      :
                      null
                    }
                  </div>
                ))}
              </div>
            ))}
          </Slider>
        );
      }
    }
  
    return null;
  };

  const RenderProductComplexion = ({ data = [], slidesToShow }) => {
    const settingsProduct = {
      dots: false,
      infinite: false,
      accessibility: false,
      arrows: true,
      adaptiveHeight: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: slidesToShow,
      ...arrowSlider,
    };
  
    if (data.length !== 0) {
      return (
        <Slider key={JSON.stringify(data)} className="product-slider" {...settingsProduct}>
          {data.map((complexionEl) => {
            const items = complexionEl.item;
            return items.map((item, index) => (
              <div key={`${item.color || index}`} className="product-slide">
                <a className="image-product d-flex mb-2" style={{ backgroundColor: item.color }} onClick={() => { const url = `${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=complexion&color=${item.color ? item.color.replace('#', '%23') : ''}`; sendAnalyticsData('Click', `Product ${item.link}`); window.location.href = url; }} >
                  {item.image ? (
                    <img src={`${item.image}?withheaders=`} alt="" />
                  ) : (
                    <span className="bg-dark ratio-1x1"></span>
                  )}
                </a>

                <div className="product-name mt-3">{`${item.name}`}</div>
                <div className='sub-category mt-2'>{item.subCategory}</div>
                <a className="tryon-pill" href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=complexion&color=${item.color ? item.color.replace('#', '%23') : ''}`}>
                  <div className='d-flex h-100 align-items-center gap-2'>
                  <span className="tryon-icon" style={{backgroundColor: item.color}}></span>
                    <span className="tryon-text">virtual try on</span>
                  </div>
                  <span className="tryon-arrow"><FiChevronRight /></span>
                </a>
              </div>
            ));
          })}
        </Slider>
      );
    }
  
    return null;
  };
  
  const RenderProductComplexionMobile = ({data = []}) => {
    if (data.length !== 0) {
      const filteredItems = data.filter(item => item.type === 'complexion' && item.category === 'cushion');
      return (
        <div 
          key={JSON.stringify(data)} 
          className="product-slider mb-4"  
          style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'end'}}
        >
          {data.map((item, itemIndex) => {
            if (item.type === 'complexion' && item.category === 'cushion') {
              return (
                <>
                  <a
                    key={itemIndex}
                    className="item-big image-product d-flex mb-4" style={{'padding': '0 10px'}}
                    href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? 
                      getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? 
                      item.color.replace('#', '%23') : ''}`}
                    onClick={() => sendAnalyticsData('Click', `Product ${item.link}`)}
                  >
                    <img className='click-tips' src='/images/click-tips.png'/>
                    {item.image ? (
                      <img src={`${item.image}?withheaders=`} width="100%" alt="" />
                    ) : (
                      <span className="bg-dark ratio-1x1"></span>
                    )}
                    
                    {itemIndex === 0 ? (
                      <p className='desc' style={{backgroundColor: '#A5B4A1'}} dangerouslySetInnerHTML={{ __html: 'More cover & soft matte finish<br/>18H Longlasting & SPF 50 PA +++<br/>Infused with CICA & Nano Hyaluron' }} />
                    ) : itemIndex === 1 ? (
                      <p className='desc' dangerouslySetInnerHTML={{ __html: 'Smooth glow finish<br/>12H Longlasting & SPF 40 PA +++<br/>Infused with CICA & Hydra Beta Glucan' }} />
                    ) : null}
                  </a>
                  {filteredItems.length === 1 ? <div className='w-100'></div>: null}
                </>
              );
            }

            if (item.type === 'complexion') {
              return (
                <a
                  key={itemIndex}
                  className="image-product d-flex" style={{'width': '33%', 'padding': '0 10px'}}
                  href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? 
                    getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? 
                    item.color.replace('#', '%23') : ''}`}
                  onClick={() => sendAnalyticsData('Click', `Product ${item.link}`)}
                >
                  {item.image ? (
                    <img src={`${item.image}?withheaders=`} width="100%" alt="" />
                  ) : (
                    <span className="bg-dark ratio-1x1"></span>
                  )}
                </a>
              );
            }
            return null; // Explicitly return null for items not matching the condition
          })}
        </div>
      );
    }
  
    return null;
  };
  
  const RenderProductComplexionLightening = ({data = []}) => {
    if (data.length !== 0) {
      return (
        <div 
        className="product-slider mb-4"  
        style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'end' }}
        >
          {data.map((item, itemIndex) => {
            if (item.type === 'lightening') {
              return (
            <a key={itemIndex} className='image-product' style={{'width': '33%', 'padding': '0 10px'}} href={`${urlVto}?name=${userName}&email=${userEmail}&phone=${userPhone}&season=${subSeason}&season_accuracy=${subSeasonAccuracy}&season_alt=${subSeasonAlt}&season_alt_accuracy=${subSeasonAccuracyAlt}&complexion=${getShade() ? getShade().replace('#', '%23') : ''}&product=foundation&color=${item.color ? item.color.replace('#', '%23') : ''}`} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
              {item.image ?
                <img src={item.image} width="100%" alt='' />
                :
                <span className='bg-dark ratio-1x1'></span>
              }
            </a>
              );
            }
            return null; // Explicitly return null for items not matching the condition
          })}
        </div>
      );
    }
  
    return null;
  };
  
  const RenderPaletteGrid = ({data = [], slidesToShow, isMobile}) => {
    const settingsPaletteSlider = {
      dots: false,
      infinite: false,
      accessibility: true,
      arrows: true,
      speed: 800,
      autoplaySpeed: 3000,
      slidesToShow: slidesToShow,
      ...arrowSlider
    }
    
    if (data.length !== 0) {
      if(isMobile){
        return(
          <>
            <div className='palette-grid'>
              {data.map((item, itemIndex) => (
                <div key={itemIndex} key={itemIndex} className='palette-grid-item' style={{backgroundColor: item}}></div>
              ))}
            </div>
          </>
          )
      }else{
        return(
          <Slider key={JSON.stringify(data)} className='product-slider' {...settingsPaletteSlider}>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='product-slide'>
                <div className='palette-grid-item' style={{backgroundColor: item}}></div>
              </div>
              ))}
          </Slider>
        )
      }
    }
  
    return null;
  };

  useEffect(() => {
    mobileAndTabletCheck();
  
    if(location.state){
      let name = location.state.name
      let email = location.state.email
      let phone = location.state.phone
      let sub_season = location.state.subseasonal
      let sub_season_accuracy = location.state.subseasonalAccuracy
      let sub_season_alt = location.state.subseasonalAlt
      let sub_season_accuracy_alt = location.state.subseasonalAccuracyAlt
      let skintone = location.state.skintone
      let tmpComplexion = location.state.complexionName.split(' ')[0]

      setSkintoneColor(skintone)
      setUserName(name)
      setUserEmail(email)
      setUserPhone(phone)
      setSubSeasonAccuracy(parseFloat(sub_season_accuracy).toFixed(0))
      setSubSeasonAlt(sub_season_alt)
      setSubSeasonAccuracyAlt(parseFloat(sub_season_accuracy_alt).toFixed(0))

      setComplexionCode(tmpComplexion)
      setComplexionName(location.state.complexionName.substr(4,location.state.complexionName.length))
      setComplexion(location.state.complexionName)
          let complexionIndex =  jsonData.complexion.findIndex(object => (object.code === tmpComplexion)) || 0;
          let resultData = {};
          setShareTemplate(sub_season);

          // for testing
          // sub_season = 'WARM AUTUMN';

          if (sub_season === 'COOL SUMMER') {
            resultData = jsonData.season[2];
            // setComplexionProducts(jsonData.complexion[0].item)
            setComplexionProducts((prev) => [
              ...prev,
              { code: jsonData.complexion[0].code, item: jsonData.complexion[0].item }
            ])
          } else if (sub_season === 'COOL WINTER') {
            resultData = jsonData.season[3];
            // setComplexionProducts(jsonData.complexion[8].item)
            setComplexionProducts((prev) => [
              ...prev,
              { code: jsonData.complexion[8].code, item: jsonData.complexion[8].item }
            ])
          } else if (sub_season === 'WARM SPRING') {
            resultData = jsonData.season[0];
            setComplexionProducts((prev) => [
              ...prev,
              { code: jsonData.complexion[2].code, item: jsonData.complexion[2].item },
              { code: jsonData.complexion[3].code, item: jsonData.complexion[3].item },
              { code: jsonData.complexion[5].code, item: jsonData.complexion[5].item },
            ]);
          } else if (sub_season === 'WARM AUTUMN') {
            resultData = jsonData.season[1];
            setComplexionProducts((prev) => [
              ...prev,
              { code: jsonData.complexion[4].code, item: jsonData.complexion[4].item },
              { code: jsonData.complexion[6].code, item: jsonData.complexion[6].item },
              { code: jsonData.complexion[7].code, item: jsonData.complexion[7].item },
            ]);
          }

          setSubSeason(sub_season);

          setResult(resultData);

          setShareComplexionProducts(jsonData.complexion[complexionIndex].share_products)
          
          triggerConvertToPdfWhenReady();
        }else{
          navigate('/')
        }

      sendAnalyticsData('View Page','Result Template Page')

  }, [location.state]);

  const postPhotoURL = 'https://wardah-colourstory.com/vto-post';

  const manualPost = (path, params, method='post') => {

    const form = document.createElement('form');
    form.method = method;
    form.action = path;
    form.enctype = 'multipart/form-data';
  
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
  
        form.appendChild(hiddenField);
      }
    }
  
    document.body.appendChild(form);
    form.submit();
  }

  const handleConvertToCanvas = () => {
    // html2canvas(captureMobileRef.current, {
    //   scale: 3,
    //   allowTaint: false,
    //   useCORS: true
    // }).then(async (canvas) => {
      // var data = canvas.toDataURL('image/jpeg'); // This is the base64 image
  
      // if (navigator.share) {
        // try {
          // await navigator.share({
          //   files: [new File([await (await fetch(data)).blob()], 'image.jpeg', { type: 'image/jpeg' })]
          // });
          
          // const postPhotoURL = 'https://localhost:3031/vto-post';
  
          // Ensure required fields are available before submitting
          if (
            location.state.photo,
            location.state.name &&
            location.state.email &&
            location.state.phone &&
            location.state.subseasonal &&
            location.state.subseasonalAccuracy &&
            location.state.subseasonalAlt &&
            location.state.subseasonalAccuracyAlt &&
            getShade()
          ) {
            manualPost(postPhotoURL, {
              "fullname": location.state.name,
              "email": location.state.email,
              "phone": location.state.phone,
              "season": location.state.subseasonal,
              "season_accuracy": parseFloat(location.state.subseasonalAccuracy).toFixed(0),
              "season_alt": location.state.subseasonalAlt,
              "season_alt_accuracy": parseFloat(location.state.subseasonalAccuracyAlt).toFixed(0),
              "complexion": getShade(),
              "photo": location.state.photo
            });

            sendAnalyticsData('Click', 'Share Button');
        //   }
        // } catch (error) {
        //   console.error('Error sharing:', error);
        // }
      }
    // });
  };

// Helper: wait until every <img> inside a container has finished loading
// (or errored out, so we never hang forever on a broken image).
const waitForImagesToLoad = (container, timeoutMs = 8000) => {
  const imgs = Array.from(container.querySelectorAll('img'));
  if (imgs.length === 0) return Promise.resolve();

  const perImage = imgs.map(img => {
    if (img.complete && img.naturalWidth !== 0) {
      return Promise.resolve();
    }
    return new Promise(resolve => {
      const done = () => {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        resolve();
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
  });

  // Safety net so a single stuck image can't block PDF generation forever
  const timeout = new Promise(resolve => setTimeout(resolve, timeoutMs));

  return Promise.race([Promise.all(perImage), timeout]);
};

const normalizeSliderTracks = (container) => {
  container.querySelectorAll('.slick-track').forEach(track => {
    track.style.setProperty('transform', 'none', 'important');
    track.style.setProperty('width', '100%', 'important');
  });
  container.querySelectorAll('.slick-slide').forEach(slide => {
    slide.style.setProperty('display', 'inline-block', 'important');
  });
};

// Waits for captureMobileRef to actually be attached to the DOM before
// kicking off PDF generation + upload, instead of guessing with a fixed
// setTimeout. Polls on rAF (cheap, tied to actual paint cycles) and gives
// up with a visible error after ~5s so we never fail silently.
const triggerConvertToPdfWhenReady = (attempt = 0) => {
  if (pdfTriggeredRef.current) return; // already fired for this result, don't double-upload

  if (captureMobileRef.current) {
    pdfTriggeredRef.current = true;
    handleConvertToPdf();
    return;
  }

  const MAX_ATTEMPTS = 300; // ~5s at 60fps
  if (attempt >= MAX_ATTEMPTS) {
    console.error("captureMobileRef never attached — aborting PDF/upload flow");
    setErrorSubmit(true);
    return;
  }

  requestAnimationFrame(() => triggerConvertToPdfWhenReady(attempt + 1));
};

const handleConvertToPdf = async () => {
  if (captureMobileRef.current === null) {
    // Shouldn't happen since triggerConvertToPdfWhenReady waits for the ref,
    // but guard anyway in case this is ever called directly (e.g. the
    // commented-out manual "Share" button).
    console.warn("captureMobileRef.current not found");
    setErrorSubmit(true);
    return;
  }

  setErrorSubmit(false);
  setErrorConnection(false);
  setErrorText('');

  try {
    setTimeout(async () => {
     try {
      const clone = captureMobileRef.current.cloneNode(true);

      // Get EXACT dimensions
      const rect = captureMobileRef.current.getBoundingClientRect();
      const originalWidth = rect.width;
      const originalHeight = rect.height;
      
      // Set clone to EXACT original dimensions
      clone.style.width = `${originalWidth}px`;
      clone.style.height = `${originalHeight}px`;
      clone.style.position = "fixed";
      clone.style.top = "0";
      clone.style.left = "0";
      clone.style.opacity = "1";
      clone.style.visibility = "visible";
      clone.style.display = "block";
      clone.style.background = "#ffffff";
      clone.style.zIndex = "9999";
      clone.style.overflow = "visible";
      clone.style.boxSizing = "border-box";

      // Remove all hidden elements
      clone.querySelectorAll("[hidden]").forEach(el => {
        el.removeAttribute("hidden");
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('height', 'auto', 'important');
      });

      // Show all panels
      clone.querySelectorAll('[role="tabpanel"]').forEach(p => {
        p.removeAttribute("hidden");
        p.style.setProperty('display', 'block', 'important');
        p.style.setProperty('visibility', 'visible', 'important');
        p.style.setProperty('opacity', '1', 'important');
        p.classList.add("active");
      });

      // Remove any overflow:hidden
      clone.querySelectorAll('*').forEach(el => {
        const computed = getComputedStyle(el);
        if (computed.overflow === 'hidden') {
          el.style.setProperty('overflow', 'visible', 'important');
        }
        if (computed.overflowX === 'hidden') {
          el.style.setProperty('overflow-x', 'visible', 'important');
        }
        if (computed.overflowY === 'hidden') {
          el.style.setProperty('overflow-y', 'visible', 'important');
        }
      });

      normalizeSliderTracks(clone);

      // Append to body
      document.body.appendChild(clone);

      // Force reflow - FIXED: Assign to variable or use void operator
      const reflow = clone.offsetHeight; // Assign to variable to fix eslint
      await new Promise(r => requestAnimationFrame(r));

      await waitForImagesToLoad(clone);

      await new Promise(r => setTimeout(r, 300));

      // Debug: Check final dimensions
      const finalRect = clone.getBoundingClientRect();

      // Capture with exact dimensions
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        width: finalRect.width,
        height: finalRect.height,
        windowWidth: finalRect.width,
        windowHeight: finalRect.height,
        scrollX: 0,
        scrollY: 0,
        logging: true,
        onclone: (clonedDoc) => {
          // Ensure body has white background
          clonedDoc.body.style.background = "#ffffff";
          clonedDoc.body.style.margin = "0";
          clonedDoc.body.style.padding = "0";
        }
      });

      clone.remove();

      // Validate canvas
      if (!canvas.width || !canvas.height || canvas.width === 0 || canvas.height === 0) {
        console.error("Canvas has invalid dimensions");
        setIsCapturing(false);
        return;
      }

      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      // Convert pixels to mm (approximate: 1px = 0.264583mm at 96 DPI)
      const pxToMm = 0.264583;
      const contentWidthMm = canvas.width * pxToMm;
      const contentHeightMm = canvas.height * pxToMm;
      
      // Create PDF with exact content dimensions (no white space)
      const pdf = new jsPDF({
        unit: 'mm',
        format: [contentWidthMm, contentHeightMm]
      });
      
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      
      // Add image to fill entire page
      pdf.addImage(imgData, "JPEG", 0, 0, pageWidth, pageHeight, undefined, 'FAST');

      // Convert PDF to Base64
      const pdfBase64 = pdf.output("datauristring").split(",")[1];

      // Upload to PCA API
      const payload = {
        image_base64: pdfBase64,
        // paragon_code: location.state.qrCode,
        paragon_code: "",
        email: location.state.email
      };

      const FETCH_TIMEOUT_MS = 30000;
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

      const res = await fetch(`https://skinanalyzer.wardahbeauty.com/api/pca/upload`, {
      // const res = await fetch(`https://api.wardah-colourintelligence.com/api/pca/upload`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!res.ok) {
        console.log(`Upload failed: ${res.status}`);
        setErrorSubmit(true);
        return;
      }

      const result = await res.json();

      setIsCapturing(false);
      sendAnalyticsData("Click", "Generated PDF & Uploaded");

     } catch (innerError) {
      if (innerError?.name === 'AbortError') {
        setErrorConnection(true);
        setErrorText("<strong class='d-block mb-2'>Connection Unstable</strong>We're having trouble connecting.<br>Please check your internet connection and try again.");
      } else {
        setErrorSubmit(true);
      }
      console.error("PDF conversion error:", innerError);
     }
    }, 3000);
  } catch (error) {
    if (error?.name === 'AbortError') {
      setErrorConnection(true);
      setErrorText("<strong class='d-block mb-2'>Connection Unstable</strong>We're having trouble connecting.<br>Please check your internet connection and try again.");
    } else {
      setErrorSubmit(true);
    }
    console.error("PDF conversion error:", error);
  }
};

// useEffect(() => {
//   handleConvertToPdf()
// }, [location.state])
  
// const handleDownloadCanvas = () => {
//   html2canvas(captureMobileRef.current, {
//     "scale": 2
//   }).then((canvas) => {
//     var data = canvas.toDataURL('image/jpeg');
//     const a = document.createElement('a');
//     a.href = data;
//     // a.target = '_blank';
//     a.download = shareTemplate+'.jpeg';
//     a.style.display = 'none';
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     sendAnalyticsData('Click','Download Button')
//   });
// };

  const getShade = () => {
    var shadeCode = '';
  
    // SPRING
    if (subSeason === 'WARM SPRING' && subSeasonAccuracy >= 92){
      shadeCode = '#21W';
    }
  
    if (subSeason === 'WARM SPRING' && subSeasonAccuracy >= 93){
      shadeCode = '#22N';
    }
    
    if(subSeason === 'WARM SPRING' && subSeasonAccuracy === 91){
      shadeCode = '#23W';
    }
    
    if(subSeason === 'WARM SPRING' && subSeasonAccuracy <= 90){
      shadeCode = '#32N';
    }
  
    // AUTUMN
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy < 91){
      shadeCode = '#31W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy <= 93 && subSeasonAccuracy >= 91){
      shadeCode = '#33W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 94){
      shadeCode = '#34W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 95){
      shadeCode = '#42N';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 96){
      shadeCode = '#41W';
    }
    
    if(subSeason === 'WARM AUTUMN' && subSeasonAccuracy >= 97){
      shadeCode = '#43W';
    }
  
    // SUMMER
    if(subSeason === 'COOL WINTER'){
      shadeCode = '';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 93){
      shadeCode = '#22C';
    }
    
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 94){
      shadeCode = '#21C';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 95){
      shadeCode = '#11C';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy >= 91 && subSeasonAccuracy <= 92){
      shadeCode = '#31C';
    }
  
    if(subSeason === 'COOL SUMMER' && subSeasonAccuracy <= 90){
      shadeCode = '#32C';
    }
    
    return (shadeCode);
  };

  return (
    <div className='w-100' style={{minHeight: '100%'}}>
      <div className={`vh-100 position-sticky result-form-wrapper top-0 start-0 w-100 bg-white ${(isCapturing || errorSubmit || errorConnection) ? 'd-block': 'd-none'}`} style={{zIndex: 9}}>
        <div className='page-wrapper d-flex justify-content-center align-items-center flex-column text-center'>
          <div className='logo-form justify-content-center align-items-center w-100'>
            <img src='/images/logo.png' alt=''/>
          </div>
          {(errorSubmit || errorConnection) ? (
            <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center pb-4'>
              <div className='loading-result-title'>
                <h2 className='mb-3'>
                  {errorConnection ? <span dangerouslySetInnerHTML={{ __html: errorText }} /> : <>We are in high demand<br/>please try again!</>}
                </h2>
              </div>

              <button
                type='button'
                className='btn btn-secondary'
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                Try again
              </button>
            </div>
          ) : (
            <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center pb-4'>
              <h3>please wait a moment..</h3>
              <img className='loader-image' src='/images/loader.png' alt=''/>
              <div className='loading-result-title'>
                <h2 className='mb-3'>Analyzing Your Personal Color</h2>
              </div>
            </div>
          )}
        </div>
        <img className='powered-logo position-absolute' src='/images/pixielab.png'/>
      </div>
      <div ref={captureMobileRef} className={`result-container result-container-mobile d-block position-relative ${(isCapturing || errorSubmit || errorConnection) ? 'hide-nav-tab' : 'show-nav-tab'}`}>
          <div className="header-container open-hint">
            {/* <div className='header-inner d-flex justify-content-end' style={{backgroundImage: `url(${result.headerBG})`}}> */}
            <div className='header-inner pt-2 d-flex justify-content-center align-items-center'>
              {/* <img className="personal" src="/images/personal.png" /> */}
              <Link onClick={() => { window.location.href = '/' }} className='back position-absolute' style={{top: '46%', left: '8%', transform: 'translateX(-50%)'}}>
                <img className='icon-back' src='/images/icon-back.png' alt=''/>
              </Link>
              <div className="logo-container">
                <img src="/images/logo.png" />
              </div>
            </div>
          </div>
          <div className='d-block d-lg-flex d-sm-flex justify-content-center'>
            <div className='column-palette-wrapper d-block d-lg-flex flex-column w-100 flex-grow-1 justify-content-end'>
              <div className='result-intro-container'>
                <h2 className='section-main-title'>Color Intelligence<br/>Prescription</h2>
                <h3>{userName}</h3>
                <div className="progress-wrap" data-season={subSeason}>
                  <div className="progress-fill" style={{width: subSeasonAccuracy+'%'}}></div>
                </div>
              </div>
              <div className='header-percentage'>
                <div className='percentage-value value-1'>
                  <div className='percentage-name'>{parseInt(subSeasonAccuracy)+'%'} {subSeason.toLowerCase()}</div>
                  {/* <div className='percentage-name'>92% Warm Autumn</div> */}
                </div>
                <div className='percentage-value value-2'>
                  <div className='percentage-name'>{subSeasonAlt.toLowerCase()} {parseInt(subSeasonAccuracyAlt)+'%'}</div>
                  {/* <div className='percentage-name'>Cool Summer 8%</div> */}
                </div>
              </div>
              <div className="palette-container d-lg-flex align-items-start">
                {/* <div className="section-title d-table mt-4" style={{minWidth: '146px'}}>COLOR PALETTES</div> */}
                <div className='palette-grid-wrapper'>
                  <RenderPaletteGrid data={result.palette} slidesToShow={5} isMobile={true}/>
                  <div className='palette-info'>
                    <div>Colour Palette</div>
                    <div>{subSeason.toLowerCase()}</div>
                  </div>
                </div>
              </div>
              <div className="complexion-container w-100 d-flex flex-column mb-4">
                {/* <p className="text-tryon-notif text-center mt-0">Click the products for Virtual  Try-On!</p> */}
                {
                  complexionProducts ? 
                    complexionProducts.map((complexionEl, index) => {
                      if(index === 0){
                        return (
                          <>
                            <div key={index} className='d-flex'>
                              <div className="section-title-container flex-grow-1">
                                {/* <img src="/images/title-complexion.png" /> */}
                                <h2 className='section-main-title mb-2 d-flex align-items-end'>Colorfit<br/>Complexion
                                  <span className='hint-swipe ms-auto'>swipe to see <FiChevronRight /></span>
                                </h2>
                              </div>
                              {/* <div className='section-palette-container d-flex align-items-center me-0 me-md-3 mt-1'>
                                <div className='d-flex align-items-center justify-content-end gap-1 gap-md-2 '>
                                  <div className="palette" style={{backgroundColor: skintoneColor}}></div>
                                  <div className="wardah-text">{getShade()}</div>
                                </div>
                              </div> */}
                            </div>
                            <div className='complexion-products-slider mt-4 mb-3'>
                              <RenderProductComplexion data={complexionProducts} slidesToShow={2}/>
                              {/* <RenderProductComplexionMobile data={complexionEl.item} /> */}
                            </div>
                            
                            {/* <div className='d-flex align-items-center gap-1'>
                              <div className="section-title-container flex-grow-1">
                                <img style={{ maxWidth: '49.5%' }} src="/images/complexion-lightening-title.png" alt="Complexion Title" />
                              </div>
                            </div> */}
                            
                            {/* <div className='complexion-products-slider mt-4' style={{ maxWidth: 'unset', width: 'auto' }}>
                              <RenderProductComplexionLightening data={complexionEl.item} />
                            </div> */}
                          </>
                        );
                      }
                    })
                  : null
                }
                
              </div>
            </div>
            {/* <div className="ecommerce-container px-3 d-none d-lg-flex flex-column align-items-center justify-content-center text-center">
              <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
              <p>
                <a id='shop-btn' className='btn' href='#' target='_blank'>Shop Now</a>
              </p>
            </div> */}
          </div>
          <div className={`d-flex flex-wrap product-tab`}>
            <div className="category-product-section nav-tab-section position-relative mb-4">
              <h2 className="section-main-title mb-4 mb-sm-5 d-flex align-items-end">Make Up <br/>Recommendation</h2>
              <div className={`nav-tab-wrapper`}>
                {tabs.map((t, idx) => {
                  const isActive = active === t.id;
                    return (
                      <div
                        key={t.id}
                        role="tab"
                        ref={(el) => (tabsRef.current[idx] = el)}
                        aria-selected={isActive}
                        aria-controls={`${t.id}-panel`}
                        id={`${t.id}-tab`}
                        tabIndex={isActive ? 0 : -1}
                        onKeyDown={(e) => handleKeyDown(e, idx, t.id)}
                        onClick={() => handleClick(t.id)}
                        className={`nav-tab-link cursor-pointer 
                        ${isActive ? "active" : ""}`}
                        >
                        {t.label}
                      </div>
                    );
                  })
                }
              </div>
            </div>
            {/* panels */}
            <div className="nav-tab-content mb-5 pb-0 pb-sm-1">
              {tabs.map((t) => {
                const isActive = active === t.id;
                return (
                  <div
                    id={`${t.id}-panel`}
                    key={t.id}
                    role="tabpanel"
                    aria-labelledby={`${t.id}-panel-tab`}
                    className={`category-product-section tab-content ${t.id} position-relative ${isActive ? "active" : ""}`}
                    hidden={active !== t.id}
                  >
                    {/* panel-local tab header (sticky) */}
                    <div
                      id={`${t.id}-panel-tab`}
                      role="tab"
                      aria-controls={`${t.id}-panel`}
                      aria-selected={isActive}
                      tabIndex={0}
                      className={`panel-tab-header nav-tab-link cursor-pointer ${isActive ? "active" : ""}`}
                      onClick={() => handleClick(t.id)}
                      onKeyDown={(e) => handleKeyDown(e, /* optional idx */ null, t.id)}
                    >
                      {t.label}
                    </div>

                    {/* PANEL CONTENT - put your render component here */}
                    <div className="panel-inner-content">
                      {t.id === "lips-section" && (RenderProductsLipsMobile ? <RenderProductsLipsMobile data={result.lips}/> : <div className="p-4">No lips component provided</div>)}
                      {t.id === "eyes-section" && (RenderProductsEyes ? <RenderProductsEyes data={result.eyes} isMobile={true}/> : <div className="p-4">No eyes component provided</div>)}
                      {t.id === "blushon-section" && (RenderProductsBlushOn ? <RenderProductsBlushOn data={result.blushOn}/> : <div className="p-4">No blush on component provided</div>)}
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
          <div className="ecommerce-container">
            <h2 className="section-main-title mb-2 mb-sm-5 d-flex align-items-end">Shop Your<br/>Beauty Match!</h2>
            <div className="ecommerce-button-container mx-auto mt-0 mb-5">
              <a href="https://www.wardahbeauty.com/id/product/list/sale/sort/makeup" className="ecommerce-button wardah" onClick={()=>{sendAnalyticsData('Click',`Wardah Website`)}} ><img className="w-100 h-100" src="/images/wardah.png" /></a>
              <a href="https://shopee.co.id/wardahofficial?categoryId=100630&entryPoint=ShopByPDP&itemId=3010539954" onClick={()=>{sendAnalyticsData('Click',`Shopee Website`)}}  className="ecommerce-button shopee"><img className="w-100 h-100" src="/images/shopee.png" /></a>
              {/* <a href="http://www.tiktok.com/" className="ecommerce-button tiktok" target='_blank'><img className="w-100 h-100" src="/images/tiktok.png" /></a> */}
              <a href="https://www.lazada.co.id/shop/wardah-ofc-store/?itemId=4640860337&spm=a2o4j.pdp_revamp.seller.1.44693987x1jJwM&path=promotion-39695-0.htm&tab=promotion&channelSource=pdp" onClick={()=>{sendAnalyticsData('Click',`Lazada Website`)}}  className="ecommerce-button lazada"><img className="w-100 h-100" src="/images/lazada.png" /></a>
              <a href="https://www.tokopedia.com/wardah-official" className="ecommerce-button tokopedia" onClick={()=>{sendAnalyticsData('Click',`Tokopedia Website`)}} ><img className="w-100 h-100" src="/images/tokopedia.png" /></a>
              <a href="https://www.tiktok.com/@wardahofficial" className="ecommerce-button tokopedia" onClick={()=>{sendAnalyticsData('Click',`Tokopedia Website`)}} ><img className="w-100 h-100" src="/images/tiktok.png" /></a>
            </div>
          </div>
          <div className='result-action-wrapper d-flex justify-content-center flex-column align-items-center mt-2 mb-5'>
            <a href='/' className='result-action btn btn-secondary'>Finish</a>
            {/* <button id="share-btn" className='result-action btn btn-secondary' onClick={handleConvertToPdf}>Share</button> */}
          </div>
          <img className='powered-logo' src='/images/pixielab.png'/>
        
        <div className='share-template-wrapper position-fixed' style={{zIndex: '-1', aspectRatio: '9/16', width: '430px', height: '920px'}}>
          <div className='share-template position-relative'>
            {/* <img className='w-100' src={`/images/share-templates/${shareTemplate}.jpg`} alt=''/> */}
            
            <p className='share-template-username'>{userName}</p>
            <img className='share-complexion-product' src={`/images/share-templates/${shareComplexionProducts}`} alt=''/>
          </div>
        </div>
        <div ref={canvasRef}></div>
    </div>
    </div>
  );
};

export default PageResultTemplate;